import React from 'react'

const Manual_importar_cambios_invu = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          ¿Cómo importar los cambios de INVU automático?
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Descubre cómo realizar la importación automática de cambios desde INVU dentro de la configuración general de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Como_importar_los_cambios_de_INVU_automatico__lGgYbKsdR8uNbb4n9q6HhQ?as=scrollable"
          className="scribe-iframe-general-116"
          width="100%"
          height="400"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_importar_cambios_invu
